import React, { useEffect, useState } from "react";
import {
  Radio,
  RadioGroup,
  FormControl,
  FormControlLabel,
  FormLabel,
} from "@material-ui/core";

//theme
import Theme, { useStyles } from "../../../Theme.js";

//Images
import VISITE_LIBRE from "../../../../images/pictos-ok/VISITE LIBRE.svg";
import VISITE_GUIDEE from "../../../../images/pictos-ok/VISITE GUIDEE.svg";
import ACTIVITE_LOISIRS from "../../../../images/pictos-ok/ACTIVITE_LOISIRS.svg";
import ACTIVITE_SPORTIVE from "../../../../images/pictos-ok/ACTIVITE_SPORTIVE.svg";
import MANIFESTATION_CULTURELLE from "../../../../images/pictos-ok/MANIFESTATION_CULTURELLE.svg";

const Step1 = (props) => {
  const classes = useStyles();
  const [value, setValue] = useState("");

  useEffect(() => {
    if (props.result.type_activite) {
      setValue(props.result.type_activite);
      props.setAuthorization(true);
      //document.getElementById(props.location.state).focus();
    } else {
      props.setAuthorization(false);
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  const handleChange = (event) => {
    // Set la value du state du composant local pour rendu graphique
    setValue(event.target.value);
    // Set la value du state du composant parent
    let newResult = props.result;
    newResult["type_activite"] = event.target.value;
    props.setResult(newResult);
    // Une fois que la réponse est donnée, autorise à avancer dans le form
    props.setAuthorization(true);
    props.goForth(true);
  };

  return (
    <FormControl component="fieldset">
      <FormLabel component="legend">
        A quel type d'activités avez vous eu à faire ?
      </FormLabel>
      <RadioGroup
        aria-label="activites"
        name="activites"
        value={value}
        onChange={handleChange}
      >
        <FormControlLabel
          value="visite_libre"
          className={
            classes.themeButton +
            " " +
            (value === "visite_libre" ? "checked" : "")
          }
          control={
            <Radio
              className={classes.fullradio}
              icon={
                <img
                  style={{
                    maxHeight: 65,
                    maxWidth: "100%",
                    marginBottom: "10px",
                  }}
                  src={VISITE_LIBRE}
                  alt="VISITE_LIBRE"
                />
              }
              checkedIcon={
                <img
                  style={{
                    maxHeight: 65,
                    maxWidth: "100%",
                    marginBottom: "10px",
                  }}
                  src={VISITE_LIBRE}
                  alt="VISITE_LIBRE"
                />
              }
            />
          }
          label="visite libre"
        />
        <FormControlLabel
          value="visite_guidée"
          className={
            classes.themeButton +
            " " +
            (value === "visite_guidée" ? "checked" : "")
          }
          control={
            <Radio
              className={classes.fullradio}
              icon={
                <img
                  style={{
                    maxHeight: 65,
                    maxWidth: "100%",
                    marginBottom: "10px",
                  }}
                  src={VISITE_GUIDEE}
                  alt="VISITE_GUIDEE"
                />
              }
              checkedIcon={
                <img
                  style={{
                    maxHeight: 65,
                    maxWidth: "100%",
                    marginBottom: "10px",
                  }}
                  src={VISITE_GUIDEE}
                  alt="VISITE_GUIDEE"
                />
              }
            />
          }
          label="visite guidée"
        />
        <FormControlLabel
          value="loisirs"
          className={
            classes.themeButton + " " + (value === "loisirs" ? "checked" : "")
          }
          control={
            <Radio
              className={classes.fullradio}
              icon={
                <img
                  style={{
                    maxHeight: 65,
                    maxWidth: "100%",
                    marginBottom: "10px",
                  }}
                  src={ACTIVITE_LOISIRS}
                  alt="ACTIVITE_LOISIRS"
                />
              }
              checkedIcon={
                <img
                  style={{
                    maxHeight: 65,
                    maxWidth: "100%",
                    marginBottom: "10px",
                  }}
                  src={ACTIVITE_LOISIRS}
                  alt="ACTIVITE_LOISIRS"
                />
              }
            />
          }
          label="activité de loisirs"
        />
        <FormControlLabel
          value="manifestation_culturelle"
          className={
            classes.themeButton +
            " " +
            (value === "manifestation_culturelle" ? "checked" : "")
          }
          control={
            <Radio
              className={classes.fullradio}
              icon={
                <img
                  src={MANIFESTATION_CULTURELLE}
                  style={{
                    maxHeight: 65,
                    maxWidth: "100%",
                    marginBottom: "10px",
                  }}
                  alt="MANIFESTATION_CULTURELLE"
                />
              }
              checkedIcon={
                <img
                  src={MANIFESTATION_CULTURELLE}
                  style={{
                    maxHeight: 65,
                    maxWidth: "100%",
                    marginBottom: "10px",
                  }}
                  alt="MANIFESTATION_CULTURELLE"
                />
              }
            />
          }
          label="manifestation culturelle"
        />
        <FormControlLabel
          value="activite_sportive"
          className={
            classes.themeButton +
            " " +
            (value === "activite_sportive" ? "checked" : "")
          }
          control={
            <Radio
              className={classes.fullradio}
              icon={
                <img
                  style={{
                    maxHeight: 65,
                    maxWidth: "100%",
                    marginBottom: "10px",
                  }}
                  src={ACTIVITE_SPORTIVE}
                  alt="activite_sportive"
                />
              }
              checkedIcon={
                <img
                  style={{
                    maxHeight: 65,
                    maxWidth: "100%",
                    marginBottom: "10px",
                  }}
                  src={ACTIVITE_SPORTIVE}
                  alt="activite_sportive"
                />
              }
            />
          }
          label="activité sportive"
        />
      </RadioGroup>
    </FormControl>
  );
};

export default Step1;
